<template>
  <!-- <Welcome></Welcome> -->
  <swiper :direction="'vertical'" :modules="modules" class="mySwiper">

    <swiper-slide>
      <Welcome />
    </swiper-slide>
    <swiper-slide>
      <Doeses />
    </swiper-slide>
    <swiper-slide>
      <Request />
    </swiper-slide>
    <swiper-slide>
      <Approved />
    </swiper-slide>
    <swiper-slide>
      <Mocero />
    </swiper-slide>

  </swiper>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import Welcome from '../../../../modules/Inventory/components/landingScreen/welcomeComponent.vue'
import Doeses from '../../../../modules/Inventory/components/landingScreen/dosesComponent.vue'
import Mocero from '../../../../modules/Inventory/components/landingScreen/moceroInventoryComponent.vue'
import Request from '../../../../modules/Inventory/components/landingScreen/requestComponent.vue'
import Approved from '../../../../modules/Inventory/components/landingScreen/requestApprovedComponent.vue'
import { Swiper, SwiperSlide } from "swiper/vue";
import { Pagination } from "swiper";

// Import Swiper styles
import "swiper/css";

import "swiper/css/pagination";

export default defineComponent({
  components: {
    Welcome,
    Doeses,
    Mocero,
    Request,
    Approved,
    Swiper,
    SwiperSlide,
  },
  setup() {
    return {
      modules: [Pagination],

    }
  }

})
</script>

<style>
#app {
  height: 100%
}

html,
body {
  position: relative;
  height: 100%;
}

body {
  background: #eee;
  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
  margin: 0;
  padding: 0;
}

.swiper {
  width: 100%;
  height: 100%;
}

.swiper-slide {
  text-align: center;
  font-size: 18px;
  background-color: #05096c;

  /* margin-bottom: 10px; */
  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}

.swiper-slide img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>